import { render, staticRenderFns } from "./FlagsDisplay.vue?vue&type=template&id=6ec680f6&scoped=true&"
import script from "./FlagsDisplay.vue?vue&type=script&lang=ts&"
export * from "./FlagsDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec680f6",
  null
  
)

export default component.exports